import { ColorModeScript } from "@chakra-ui/react";
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import * as ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";
import store from "./store";
import { PostHogProvider } from "posthog-js/react";
import { HelmetProvider } from "react-helmet-async";
import { sanitizeLocalStorage } from "./utils/storageSanitizer";
import { loadExperimentControls } from "./utils/experimentControls";

// Clear any corrupted/stale saved state BEFORE React mounts, so a bad value
// from an old version or a dead session can never hang the homepage. Runs
// synchronously; only removes unreadable/known-bad data.
sanitizeLocalStorage();

// Admin switches for live A/B tests. Non-blocking: the cached value is already
// available synchronously, this only refreshes it for the next page view.
loadExperimentControls();

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

// PostHog options - cookieless mode by default for GDPR compliance
// Memory-only persistence means NO cookies/localStorage are used until consent.
// This allows basic analytics (pageviews, events) without storing anything on the
// user's device, which is GDPR-compliant. After cookie consent, we upgrade to
// persistent storage + session recording via enablePostHogTracking().
const options = {
  api_host: "https://eu.i.posthog.com",
  persistence: 'memory',              // No cookies/localStorage until consent
  autocapture: true,                   // Capture clicks, inputs etc. in memory
  capture_pageview: true,              // Track page views
  capture_pageleave: true,             // Track page leaves
  disable_session_recording: false,    // Load the recorder SDK so it's ready
  session_recording: {
    recordCrossOriginIframes: false,   // Must be false — true causes SecurityError freezes on pages with Stripe/payment iframes
  },
  person_profiles: 'identified_only',  // Only create person profiles for identified users
};

root.render(
  <PostHogProvider
    apiKey={"phc_YEmSIoQbHaTTyUY98oLdKHqRqwOp0dflVfr0As8g9v9"}
    options={options}
  >
    <Provider store={store}>
      <ColorModeScript />
      <CookiesProvider defaultSetOptions={{ path: "/" }}>
        <Router>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </Router>
      </CookiesProvider>
    </Provider>
  </PostHogProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
